import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Box
} from '@mui/material';
import {
  PersonAdd as PersonIcon,
  Payment as PaymentIcon,
  Verified as VerifiedIcon
} from '@mui/icons-material';
import moment from 'moment';

const RecentActivities = ({ activities }) => {
  const getIcon = (type) => {
    switch (type) {
      case 'user_joined':
        return <PersonIcon />;
      case 'payment':
        return <PaymentIcon />;
      case 'verification':
        return <VerifiedIcon />;
      default:
        return <PersonIcon />;
    }
  };

  const getColor = (type) => {
    switch (type) {
      case 'user_joined':
        return '#4caf50';
      case 'payment':
        return '#2196f3';
      case 'verification':
        return '#ff9800';
      default:
        return '#9e9e9e';
    }
  };

  const getMessage = (activity) => {
    switch (activity.type) {
      case 'user_joined':
        return `${activity.first_name} ${activity.last_name} joined the platform`;
      case 'payment':
        return `${activity.first_name} ${activity.last_name} made a payment`;
      case 'verification':
        return `${activity.first_name} ${activity.last_name} got verified`;
      default:
        return 'New activity';
    }
  };

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Recent Activities
      </Typography>
      <List>
        {activities && activities.length > 0 ? (
          activities.map((activity, index) => (
            <React.Fragment key={index}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: getColor(activity.type) }}>
                    {getIcon(activity.type)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={getMessage(activity)}
                  secondary={moment(activity.timestamp).fromNow()}
                />
              </ListItem>
              {index < activities.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))
        ) : (
          <ListItem>
            <ListItemText primary="No recent activities" />
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

export default RecentActivities;